var ImageUrls = 'https://yousubao.oss-cn-shenzhen.aliyuncs.com/'

// 图片处理
export function urlLoad (val) {
    if(val == undefined || val == ""){
      return ""
    }else if (val.indexOf("https://yousubao-01.com/ossfile") !== -1) {
      return val.replace('https://yousubao-01.com/ossfile', ImageUrls)
    } else {
      if (val.indexOf('https://yousubao-test.oss-cn-shenzhen.aliyuncs.com') !== -1 || val.indexOf('https://yousubao.oss-cn-shenzhen.aliyuncs.com') !== -1) {
        return val
      } else {
        return (ImageUrls + val)
      }
    }
  }